import {
  actions as dataFetchActions,
  actionTypes as dataFetchActionTypes,
} from '@bufferapp/async-data-fetch';
import { actions as analyticsActions } from '~/analytics-middleware/actions';
import { actions as notificationActions } from '@bufferapp/notifications';
import { getURL } from '~/server/formatters';
import { campaignTab, campaignsPage, getParams } from '~/routes';
import { actionTypes } from './reducer';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);
    const state = getState();
    switch (action.type) {
      case actionTypes.FETCH_CAMPAIGN: {
        const { campaignId, past, status, fullItems } = action;

        dispatch(
          dataFetchActions.fetch({
            name: 'getCampaign',
            args: {
              campaignId,
              status: status || undefined,
              past,
              fullItems: fullItems || false,
            },
          })
        );
        break;
      }

      case actionTypes.GO_TO_ANALYZE_REPORT: {
        const { id, name } = action.campaign;
        const metadata = {
          campaignId: id,
          campaignName: name,
        };
        dispatch(
          analyticsActions.trackEvent('Campaign Report Viewed', metadata)
        );
        window.location.assign(`${getURL.getAnalyzeReportUrl(id)}`);
        break;
      }

      case `getCampaign_${dataFetchActionTypes.FETCH_FAIL}`:
        dispatch(
          notificationActions.createNotification({
            notificationType: 'error',
            message: action.error,
          })
        );
        dispatch(campaignsPage.goTo());
        break;

      case actionTypes.PUSHER_CAMPAIGN_UPDATED: {
        const { campaign } = action;
        const { pathname } = state.router.location;
        const sentParams = getParams({ pathname, route: campaignTab.route });
        if (sentParams) {
          dispatch(
            dataFetchActions.fetch({
              name: 'getCampaign',
              args: {
                campaignId: campaign.id,
                status: sentParams.tab,
                fullItems: true,
              },
            })
          );
        }
        break;
      }

      default:
        break;
    }
  };
